// Cart-page shipping estimate widget. Governorate/city data and fees are
// embedded inline by the section (see marika-cart-shipping-estimate.liquid)
// rather than fetched from the companion app's App Proxy — that app isn't
// deployed/installed on this store yet, so the proxy path 404s. Revisit once
// it is, if per-city fee overrides are ever needed beyond the flat
// per-governorate rate Shopify's native shipping zones already charge.
(function () {
  var script = document.currentScript;
  var resultTemplate = script ? script.dataset.resultTemplate || '' : '';
  var freeLabel = script ? script.dataset.freeLabel || 'Free' : 'Free';

  function formatResult(display) {
    return resultTemplate.replace('__FEE__', display);
  }

  function init() {
    var root = document.querySelector('[data-marika-shipping-estimate]');
    var dataEl = document.querySelector('[data-marika-shipping-areas]');
    if (!root || !dataEl) return;

    var areas;
    try {
      areas = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var governorates = Object.keys(areas || {});
    if (!governorates.length) return;

    var cartTotalCents = Number(root.dataset.cartTotalCents) || 0;
    var freeShippingCents = Number(root.dataset.freeShippingCents) || 0;
    var governorateSelect = root.querySelector('[data-marika-governorate-select]');
    var citySelect = root.querySelector('[data-marika-city-select]');
    var resultEl = root.querySelector('[data-marika-shipping-result]');

    governorates.forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      governorateSelect.appendChild(option);
    });

    function populateCities() {
      citySelect.innerHTML = '';
      var cities = (areas[governorateSelect.value] && areas[governorateSelect.value].cities) || [];
      cities.forEach(function (city) {
        var option = document.createElement('option');
        option.value = city;
        option.textContent = city;
        citySelect.appendChild(option);
      });
      showEstimate();
    }

    function showEstimate() {
      var area = areas[governorateSelect.value];
      if (!area) {
        resultEl.hidden = true;
        return;
      }
      var display = freeShippingCents > 0 && cartTotalCents >= freeShippingCents ? freeLabel : area.fee_display;
      resultEl.textContent = formatResult(display);
      resultEl.hidden = false;
    }

    governorateSelect.addEventListener('change', populateCities);
    citySelect.addEventListener('change', showEstimate);

    populateCities();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
